import { render, staticRenderFns } from "./ContentNone.vue?vue&type=template&id=7fa645ba&"
import script from "./ContentNone.vue?vue&type=script&lang=js&"
export * from "./ContentNone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports